import { Box } from '@mui/material';
import HeaderLogo from './HeaderLogo';

function SplashScreen() {
  return (
    <Box
      sx={{
        alignItems: 'center',
        backgroundColor: 'background.paper',
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        justifyContent: 'center',
        left: 0,
        p: 3,
        position: 'fixed',
        width: '100%',
        zIndex: 2000,
      }}
    >
      <HeaderLogo height={{ xs: 60, sm: 80 }} />
    </Box>
  );
}

export default SplashScreen;
